module.exports = __webpack_public_path__ + "img/mbanner2_tv.bf4c3c43.jpg";